/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Tue Nov 26 2024
 **/

import * as Drawing from "./DrawingIcons";
import * as History from "./HistoryIcons";
import * as Status from "./StatusIcons";

export const Icons: Record<string, JSX.Element> = {
	cursor: <Drawing.CursorIcon />,
	pointer: <Drawing.PointerIcon />,
	freeline: <Drawing.FreelineIcon />,
	line: <Drawing.LineIcon />,
	arrow: <Drawing.ArrowIcon />,
	marker: <Drawing.MarkerIcon />,
	circle: <Drawing.CircleIcon />,
	rect: <Drawing.RectIcon />,
	color: <Drawing.ColorIcon />,
	expandArrow: <Drawing.ExpandArrowIcon />,
	eraser: <Drawing.EraserIcon />,
	emoji: <Drawing.EmojiIcon />,
	thickness: <Drawing.ThicknessIcon />,
	image: <Drawing.ImageIcon />,
	text: <Drawing.TextIcon />,
	undo: <History.UndoIcon />,
	redo: <History.RedoIcon />,
	clearAll: <History.ClearIcon />,
	open: <Status.OpenIcon />,
	close: <Status.CloseIcon />,
	minimize: <Status.MinimizeIcon />,
	maximize: <Status.MaximizeIcon />
};

export default Icons;
